"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var am4core = _interopRequireWildcard(require("@amcharts/amcharts4/core"));

var am4plugins_forceDirected = _interopRequireWildcard(require("@amcharts/amcharts4/plugins/forceDirected"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = require("react");

var _themeUi = require("theme-ui");

var _amChartsApi = _interopRequireDefault(require("../../amChartsApi/amChartsApi"));

var _useAmChart = _interopRequireDefault(require("../../hooks/useAmChart"));

var _useAmChartData2 = _interopRequireDefault(require("../../hooks/useAmChartData"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ForceDirectedTreeChart = function ForceDirectedTreeChart(_ref) {
  var chartId = _ref.chartId,
      data = _ref.data,
      config = _ref.config,
      zoomPercentage = _ref.zoomPercentage,
      onZoomChange = _ref.onZoomChange,
      props = _objectWithoutPropertiesLoose(_ref, ["chartId", "data", "config", "zoomPercentage", "onZoomChange"]);

  var context = (0, _themeUi.useThemeUI)();
  var themeRef = (0, _react.useRef)(context.theme);

  var _useState = (0, _react.useState)(),
      minNodeVal = _useState[0],
      setMinNodeVal = _useState[1];

  var _useState2 = (0, _react.useState)(),
      maxNodeVal = _useState2[0],
      setMaxNodeVal = _useState2[1];

  var chart = (0, _useAmChart["default"])(chartId, am4plugins_forceDirected.ForceDirectedTree);
  var onDataChange = (0, _react.useCallback)(function (_ref2) {
    var newData = _ref2.newData,
        removedData = _ref2.removedData,
        updatedData = _ref2.updatedData;
    var requestChartRedraw = false;
    newData.forEach(function (dataItem) {
      chart.addData(dataItem);
    });

    if (removedData.length > 0) {
      requestChartRedraw = true;
    }

    if (updatedData.length > 0) {
      requestChartRedraw = true;
    }

    if (requestChartRedraw) {
      invalidateData();
    }
  }, [chart, invalidateData]);

  var _useAmChartData = (0, _useAmChartData2["default"])(chart, data, onDataChange),
      invalidateData = _useAmChartData.invalidateData;

  (0, _react.useEffect)(function () {
    if (config.zoomable) {
      var _minNodeVal;

      var _maxNodeVal;

      data.forEach(function (dataItem) {
        if (_minNodeVal === undefined || dataItem.value === undefined || _minNodeVal > dataItem.value) {
          _minNodeVal = dataItem.value;
        }

        if (_maxNodeVal === undefined || _maxNodeVal < dataItem.value) {
          _maxNodeVal = dataItem.value;
        }
      });
      setMinNodeVal(_minNodeVal);
      setMaxNodeVal(_maxNodeVal);
    }
  }, [config.zoomable, data]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    chart.series.setAll([new am4plugins_forceDirected.ForceDirectedSeries()]);

    if (config.zoomable) {
      if (config.zoomResetTo) {
        var zoomOutButtonId = 'id-zoom-out-button';
        var zoomOutButtonEl = chart.children.values.find(function (child) {
          return child.id === zoomOutButtonId;
        });

        if (zoomOutButtonEl) {
          zoomOutButtonEl.dispose();
        }

        var zoomOutButton = _amChartsApi["default"].zoomOutButton().create(zoomOutButtonId);

        zoomOutButton.parent = chart;
        zoomOutButton.hide();
        chart.zoomOutButton = zoomOutButton;
      }

      var sliderContainerId = 'id-slider-container';
      var sliderContainerEl = chart.children.values.find(function (child) {
        return child.id === sliderContainerId;
      });

      if (sliderContainerEl) {
        sliderContainerEl.dispose();
      }

      var sliderContainer = new am4core.Container();

      var slider = _amChartsApi["default"].scrollbar().create('slider');

      slider.parent = sliderContainer;
      chart.scrollbar = slider;
      sliderContainer.id = sliderContainerId;
      chart.children.unshift(sliderContainer);
      chart.layout = 'absolute';
      slider.startGrip.disabled = true;
      slider.thumb.interactionsEnabled = false;
      slider.thumb.focusable = false;

      slider.background.events._listeners.find(function (event) {
        return event.type === 'hit';
      }).disposer.dispose();
    }
  }, [chart, config.zoomable, config.zoomResetTo]);
  var calcNodeRadius = (0, _react.useCallback)(function (node) {
    var inputVal = node.dataItem.value ? node.dataItem.value : minNodeVal;
    var valAsPercentage = (inputVal - minNodeVal) * 100 / (maxNodeVal - minNodeVal);
    var valTranslated = valAsPercentage * (config.maxBaseRadius - config.minBaseRadius) / 100 + config.minBaseRadius;
    var nodeRadius = valTranslated * (chart.scrollbar.range.end + 0.5);
    return nodeRadius;
  }, [chart, config.maxBaseRadius, config.minBaseRadius, maxNodeVal, minNodeVal]);
  var calcNodeFontSize = (0, _react.useCallback)(function (node) {
    var nodeRadius = node.circle.radius;

    if (nodeRadius > 32) {
      return 16;
    } else if (nodeRadius > 16) {
      return 12;
    } else {
      return 10;
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    if (config.zoomable) {
      var sliderHitEvent = chart.scrollbar.background.events.on('hit', function (ev) {
        var scrollbar = ev.target.parent;
        var point = ev.spritePoint;

        if (scrollbar.isBusy) {
          scrollbar.makeUnbusyReal();
        }

        scrollbar.end = Math.floor(point.x) / scrollbar.background.measuredWidth;
      }, _this);
      var sliderRangeEvent = chart.scrollbar.events.on('rangechanged', function (ev) {
        if (!ev.target) {
          return;
        }

        if (chart.series.values[0]) {
          chart.series.values[0].nodes.values.forEach(function (node) {
            node.circle.radius = calcNodeRadius(node);
            node.fontSize = calcNodeFontSize(node);
          });
        }

        if (onZoomChange) {
          onZoomChange(ev.target.end);
        }
      });
      return function () {
        sliderHitEvent.dispose();
        sliderRangeEvent.dispose();
      };
    }
  }, [chart, config.zoomable, config.zoomResetTo, onZoomChange, minNodeVal, maxNodeVal, calcNodeRadius, calcNodeFontSize]);
  (0, _react.useEffect)(function () {
    if (!chart || !chart.zoomOutButton) {
      return;
    }

    if (config.zoomable) {
      var sliderRangeEvent = chart.scrollbar.events.on('rangechanged', function (ev) {
        if (!ev.target) {
          return;
        }

        if (chart.scrollbar.range.end !== config.zoomResetTo) {
          chart.zoomOutButton.show();
        } else {
          chart.zoomOutButton.hide();
        }
      });
      var onHitZoomOutButton = chart.zoomOutButton.events.on('hit', function () {
        var scrollbar = chart.scrollbar;

        if (scrollbar.isBusy) {
          scrollbar.makeUnbusyReal();
        }

        scrollbar.end = 0.5;
      }, _this);
      return function () {
        sliderRangeEvent.dispose();
        onHitZoomOutButton.dispose();
      };
    }
  }, [chart, config.zoomable, config.zoomResetTo]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    if (config.zoomable) {
      chart.series.values[0].nodes.template.circle.adapter.add('radius', function (radius, target) {
        var node = target.parent;
        var nodeRadius = calcNodeRadius(node);
        return nodeRadius ? nodeRadius : radius;
      });
      chart.series.values[0].nodes.template.adapter.add('fontSize', function (fontSize, target) {
        var node = target;
        return calcNodeFontSize(node);
      });
    }
  }, [calcNodeFontSize, calcNodeRadius, chart, config.zoomable]);
  (0, _react.useEffect)(function () {
    if (!chart) {
      return;
    }

    var theme = themeRef.current;
    var series = chart.series.values[0];
    series.dataFields.color = 'color';
    series.nodes.template.tooltipText = '{tooltip}';

    _amChartsApi["default"].tooltip(series.tooltip).setDefaultStyles(theme);

    series.dataFields.fixed = 'fixed';
    series.dataFields.id = '_id';
    series.dataFields.linkWith = 'link';
    series.links.template.adapter.add('strokeWidth', function (strokeWidth, target) {
      var sourceNodeData = target.source.dataItem;
      var targetNodeData = target.target.dataItem;
      var targetNodeId = targetNodeData.id;

      if (sourceNodeData.dataContext.linkConfigs[targetNodeId]) {
        return sourceNodeData.dataContext.linkConfigs[targetNodeId].strokeWidth;
      }

      return 1;
    });
    series.links.template.adapter.add('strokeDasharray', function (strokeDasharray, target) {
      var sourceNodeData = target.source.dataItem;
      var targetNodeData = target.target.dataItem;
      var targetNodeId = targetNodeData.id;

      if (sourceNodeData.dataContext.linkConfigs[targetNodeId]) {
        return sourceNodeData.dataContext.linkConfigs[targetNodeId].strokeDasharray;
      }

      return 1;
    });

    if (config.zoomable) {
      _amChartsApi["default"].scrollbar(chart.scrollbar).setDefaultStyles(theme);

      chart.scrollbar.parent.height = 100;
      chart.scrollbar.parent.padding(24, 24, 24, 24);
      chart.scrollbar.parent.width = am4core.percent(100);

      if (chart.zoomOutButton) {
        _amChartsApi["default"].zoomOutButton(chart.zoomOutButton).setDefaultStyles(theme);

        chart.zoomOutButton.layout = 'absolute';
        chart.zoomOutButton.marginTop = 64;
        chart.zoomOutButton.marginRight = 24;
        chart.zoomOutButton.align = 'right';
        chart.zoomOutButton.valign = 'top';
      }
    }

    series.links.template.adapter.add('stroke', function (strokeDasharray, target) {
      return am4core.color('#AAA');
    });
    series.dataFields.value = 'value';
    series.dataFields.label = 'label';
    series.dataFields.children = 'children';
    series.nodes.template.label.text = '{label}';
    series.nodes.template.togglable = false;

    if (!config.zoomable) {
      series.nodes.template.adapter.add('fontSize', function (fontSize, target) {
        if (!target) {
          return;
        }

        if (target.dataItem.value > 32) {
          return 16;
        } else if (target.dataItem.value > 16) {
          return 12;
        }

        return 10;
      });
    }

    series.minRadius = config.minBaseRadius;
    series.maxRadius = config.maxBaseRadius;
    series.links.template.configField = 'configLink';
    series.links.template.stroke = 'red';
    series.links.template.fill = 'red';
  }, [chart, config.maxBaseRadius, config.minBaseRadius, config.zoomable, context.theme.colors.background]);
  (0, _react.useEffect)(function () {
    if (!chart || !config.zoomable || !zoomPercentage) {
      return;
    }

    if (zoomPercentage !== chart.scrollbar.end) {
      chart.scrollbar.end = zoomPercentage;
    }
  }, [chart, config.zoomable, zoomPercentage]);
  return (0, _themeUi.jsx)("div", _extends({}, props, {
    id: chartId,
    sx: {
      width: '100%',
      height: 13
    }
  }));
};

ForceDirectedTreeChart.propTypes = {
  chartId: _propTypes["default"].string.isRequired,
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].number.isRequired
  })),
  config: _propTypes["default"].shape({
    zoomable: _propTypes["default"].bool,
    zoomResetTo: _propTypes["default"].number,
    minBaseRadius: _propTypes["default"].number,
    maxBaseRadius: _propTypes["default"].number
  }),
  zoomPercentage: _propTypes["default"].number,
  onZoomChange: _propTypes["default"].func
};
ForceDirectedTreeChart.defaultProps = {
  data: null,
  config: {
    zoomable: false,
    minBaseRadius: 16,
    maxBaseRadius: 40
  }
};
var _default = ForceDirectedTreeChart;
exports["default"] = _default;